// extracted by css-extract-rspack-plugin
export default {"textChart":"textChart-NuZLOm","card":"card-AqSCZm","preview":"preview-MLiibQ","body":"body-Sr9z39","cardBody":"cardBody-K35Pvt","previewBody":"previewBody-UFh0Jj"};